export default "__VITE_ASSET__D9gR$Thj__"